import { PropTypes } from 'react-desc';

var gridProps = {
  /** Row layout cells */
  rows: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).description('Row layout cells'),

  /** Column layout cells */
  cols: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).description('Column layout cells'),

  /** Grid span */
  span: PropTypes.number.description('Grid span'),

  /** flex-like align items prop */
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']).description('flex-like align items prop'),

  /** Children node inside grid cell */
  children: PropTypes.node.description('Children node inside grid cell'),

  /** CSS class */
  className: PropTypes.string.description('CSS class'),

  /** flex-like direction prop */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']).description('flex-like direction prop'),

  /** flex-like justify prop */
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']).description('flex-like justify prop'),

  /** Space between cells prop */
  gutter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).description('Space between cells prop'),

  /** Wrap type */
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']).description('Wrap type')
};

export { gridProps };
//# sourceMappingURL=props.js.map
